import React from "react";
import { Divider as MUIDivider, DividerProps as MUIDividerProps } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface CustomDividerProps extends Omit<MUIDividerProps, "sx"> {
    className?: string;
    sx?: SxProps<Theme>;
}

const Divider: React.FC<CustomDividerProps> = ({ className = "", sx, ...rest }) => {
    return <MUIDivider className={className} sx={sx} {...rest} />;
};

export default Divider;
